import type { Point } from "../shared/schema";

export type LineAxis = "horizontal" | "vertical";

/** Suggested sheet-axis alignment, bounded in screen pixels at every zoom. */
export function getLineAlignment(
  start: Point,
  point: Point,
  zoom: number,
  previous: LineAxis | null = null,
): { point: Point; axis: LineAxis | null } {
  const dx = Math.abs(point.x - start.x);
  const dy = Math.abs(point.y - start.y);
  const axis: LineAxis = dx >= dy ? "horizontal" : "vertical";
  const along = Math.max(dx, dy);
  const across = Math.min(dx, dy);
  // A wider release threshold avoids flickering at the edge of the guide zone.
  const held = previous === axis;
  if (
    along * zoom < 12 ||
    across * zoom > (held ? 16 : 10) ||
    across > along * Math.tan(((held ? 10 : 6) * Math.PI) / 180)
  )
    return { point, axis: null };
  return {
    point:
      axis === "horizontal"
        ? { x: point.x, y: start.y }
        : { x: start.x, y: point.y },
    axis,
  };
}
